import { Action, DialogPosition, ErrorCodes, OperationType, Position, WindowType } from "puzzle";
import PreviewTask from "../../components/SupplierView/TaskList/Actions/PreviewTask/PreviewTask";

export const previewTask: Action = [{
  data: {
    confirmActionName: 'previewRequest'
  },
  persistent: [
    'confirmActionName',
    'selectedTask',
    'onlineEditorParams',
    'previewTaskUrl',
    'method'
  ],
  type: OperationType.addPersistentData
}, {
  name: 'previewWarningDialog',
  type: OperationType.action
}];

export const previewRequest: Action = [{
  data: {
    template: {
      bind: {
        method: '{method}',
        url: '{previewTaskUrl}',
        params: '{onlineEditorParams}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.FORBIDDEN,
    ErrorCodes.NOT_FOUND,
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.INTERNAL_SERVER_ERROR
  ],
  mappingName: 'onlineEditorUrl',
  type: OperationType.request
}, {
  name: 'clearPersistentData',
  type: OperationType.action
}, {
  data: {
    template: {
      endpointPrefix: 'EDITOR_URLS_',
      bind: {
        responseData: '{onlineEditorUrl}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'ActionExecutor',
  name: 'openInPreviewMode',
  args: ['onlineEditorUrl'],
}];

export const previewWarningDialog: Action = [{
  className: 'sm warning footer-centered preview-task',
  title: 'previewTask.title',
  children: [{
    render: PreviewTask,
  }],
  items: [{
    operations: [{
      name: 'clearPersistentData',
      type: OperationType.action
    }],
    btnName: 'previewTask.back',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    close: false,
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      evaluate: true,
      name: '{confirmActionName}',
      type: OperationType.action
    }],
    btnName: 'previewTask.confirm',
    btnConfig: {
      pos: Position.end,
      disabled: true,
      themeColor: 'primary'
    }
  }, {
    close: false,
    btnName: 'ESCAPE',
    operations: [{
      index: DialogPosition.last,
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    },{
      name: 'clearPersistentData',
      type: OperationType.action
    }]
  }],
  type: OperationType.dialog
}];

export const changeConfirmButton: Action = [{
  buttons: [{
    name: 'previewTask.confirm',
    disabled: '!{buttonDisabled}'
  }],
  type: OperationType.updateDialog
}];

export const clearPersistentData = [{
  persistent: [
    'confirmActionName',
    'selectedTask',
    'onlineEditorParams',
    'previewTaskUrl',
    'method'
  ],
  type: OperationType.removePersistentData
}];

export const previewWarningAndDownload = [{
  persistent: [
    'confirmActionName',
    'submissionData',
    'params'
  ],
  type: OperationType.addPersistentData
}, {
  name: 'previewWarningDialog',
  type: OperationType.action
}]